<template>
  <SloSelect
    v-if="productHasMinOrderQuantity"
    v-model="selectedQuantity"
    :placeholder="'Select a quantity' | t"
    class="m-0"
    style="min-width: 95px; max-width: 95px;"
  >
    <option
      v-for="quantity in minOrderQuantityOptions"
      :key="`subscription-quantity-${quantity}`"
      v-html="quantity"
      :value="quantity"
    />
  </SloSelect>
  <SloNumberInput
    v-else
    :initialValue="selectedQuantity"
    :min="1"
    :min-error-text="'You must add a quantity of at least one for an item.' | t"
    :max="999"
    :max-error-text="'You can only order a maximum of 999 quantity for an item.'| t"
    @inputUpdate="handleInputUpdate($event)"
    @valueUpdate="handleInputUpdate($event)"
    class="add-subscription--quantity fw-book"
  />
</template>

<script>
import t from '../../js/main/i18n';
import SloSelect from './SloSelect.vue';
import SloNumberInput from './SloNumberInput.vue';

export default {
  name: 'SloQuantityInput',
  components: {
    SloNumberInput,
    SloSelect
  },
  filters: {
    t
  },
  props: {
    quantity: {type: String|Number, default: 1},
    min: {type: String|Number, default: 1},
    max: {type: String|Number, default: 999}
  },
  data() {
    return {
      selectedQuantity: 1
    };
  },
  computed: {
    productHasMinOrderQuantity() {
      return this.min > 1;
    },
    minOrderQuantityOptions() {
      return Array.from({length: 10}, (_, i) => this.min * (i + 1));
    }
  },
  mounted() {
    this.selectedQuantity = this.quantity;
  },
  watch: {
    quantity(value) {
      this.selectedQuantity = value;
    },
    selectedQuantity(value) {
      this.$emit('updated', value);
    }
  },
  methods: {
    handleInputUpdate(value) {
      this.selectedQuantity = value;
    }
  }
};
</script>
